<template>
  <div class="pa-3">
    <v-row justify="right" align="center" style="min-height:80px">
      <v-col class="d-flex flex-row" cols="12" md="12" lg="12" sm="12" v-if="campaignList.length">
        <v-autocomplete
          filled
          :items="campaignList"
          label="Campaign"
          item-value="id"
          hide-details
          item-text="searchText"
          v-model="campaignID"
        >
          <template v-slot:selection="{ item }">
            <div v-if="item === Object(item)" class="campaign-payment-selection">
              <span class="campaign-payment-selection__name">{{ item.name }}</span>
              <span v-if="item.ioNumber" class="campaign-payment-selection__io">{{ item.ioNumber }}</span>
            </div>
          </template>
          <template v-slot:item="{ item }">
            <CampaignListPaymentStatus :item="item"/>
          </template>
        </v-autocomplete>
        <v-btn
          class="ml-2"
          style="height:56px"
          :disabled="!campaignID"
          small
          color="warning"
          @click="getPairedInfluencers(campaignID, true)"
        >
          <v-icon color="white" small>mdi-cached</v-icon> Refresh
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="campaignCOEB && campaignCOEB.campaignId">
        <v-card color="#CFD8DC">
          <!-- <v-card-subtitle class="subtitle-1 pb-0">{{ client ? client.name : '' }}</v-card-subtitle> -->
          <v-card-subtitle class="title pb-0">
            Campaign Name: {{ campaignCOEB.campaignName || 'N/A' }}
            <v-chip color="error" v-if="campaignCOEB.lockedCOGS" small>
              <span style="color:#fff"><v-icon v-on="on" small left>mdi-lock</v-icon>Locked COGS</span>
            </v-chip>
          </v-card-subtitle>
          <v-card-title class="subtitle-1">
            Client Name: {{ campaignCOEB.clientName || 'N/A' }}
          </v-card-title>

          <v-card-subtitle class="subtitle-1 pt-2">
            IO Number: {{ campaignCOEB.ioNumbers || 'N/A' }}
          </v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>
    <!-- Pairing Data Table Section -->
    <v-layout class="mb-2 flex-row-reverse" wrap>
      <v-flex xs12 md4>
        <v-text-field
        v-model="briefConfirmationSearch"
        append-icon="search"
        label="Search"
        single-line
        hide-details>
        </v-text-field>
      </v-flex>
    </v-layout>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="pairedHeaders"
          :items="pairedInfluencers"
          :items-per-page="-1"
          :search="briefConfirmationSearch"
          :no-data-text="'Empty list'"
          class="elevation-1 page__table"
          :key="dataTableKey"
        >
          <template v-slot:body="props">
            <tbody>
              <tr v-if="props.items && props.items.length === 0">
                <td>No Data</td>
              </tr>
              <tr v-for="item in props.items" :key="item.influencer_details.instagramHandle">
                <td>
                  <div class="payment-status-handle">
                    <social-handle
                      divClassName="d-inline"
                      :isTikTok="item.influencer_details.platform === 'tiktok'"
                      :isInstagram="!item.influencer_details.platform || item.influencer_details.platform === 'instagram'"
                      :isFacebook="item.influencer_details.platform === 'facebook'"
                      :isLinkedIn="item.influencer_details.platform === 'linkedin'"
                      :isTwitter="item.influencer_details.platform === 'twitter'"
                      :isYoutube="item.influencer_details.platform === 'youtube'"
                      :isXiaohongshu="item.influencer_details.platform === 'xiaohongshu'"
                      :isOthers="item.influencer_details.platform === 'others'"
                      :tiktokHandle="item.influencer_details.instagramHandle"
                      :instagramHandle="item.influencer_details.instagramHandle"
                      :facebookHandle="getPlatformHandle(item.influencer_details, 'facebook')"
                      :linkedinHandle="item.influencer_details.linkedinHandle || item.influencer_details.userHandle || item.influencer_details.instagramHandle"
                      :twitterHandle="getPlatformHandle(item.influencer_details, 'twitter')"
                      :youtubeHandle="item.influencer_details.instagramHandle"
                      :youtubeURL="item.influencer_details.url"
                      :xiaohongshuHandle="item.influencer_details.xhsID"
                      :xiaohongshuFullName="item.influencer_details.fullName"
                      :otherHandle="item.influencer_details.instagramHandle"
                    />
                    <v-tooltip v-if="item.influencer_details && item.influencer_details.influencerID" bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon class="ml-1" color="green" small v-on="on">done</v-icon>
                      </template>
                      <span>Registered on IMS</span>
                    </v-tooltip>
                    <v-tooltip v-else bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon class="ml-1" color="red" small v-on="on">cancel</v-icon>
                      </template>
                      <span>Not registered in IMS</span>
                    </v-tooltip>
                  </div>
                  <v-menu
                    bottom
                    origin="center center"
                    transition="scale-transition"
                    v-if="item.multipleInfs && item.multipleInfs.length > 1"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        dark
                        text
                        v-bind="attrs"
                        v-on="on"
                        style="min-width:0;padding:0;margin-left:-9px;margin-top:-3px;"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon class="ml-2" color="secondary" v-on="on" small>mdi-chevron-down-circle</v-icon>
                          </template>
                          <span>Multiple Accounts detected</span>
                        </v-tooltip>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item
                        v-for="(obj, i) in item.multipleInfs"
                        :key="i"
                      >
                        <v-list-item-title>
                          <!-- <v-avatar size="35" color="grey lighten-4">
                            <img
                              class="elevation-6"
                              v-bind:src="paserImageUrl(obj.picture)"
                              alt="avatar"
                            >
                          </v-avatar> -->
                          <a
                            v-if="obj.xhs"
                          ><img src="/static/img/xhs-black.png" width="20px" /> @{{obj.handle}}</a>
                          <a
                            v-else-if="obj.facebook"
                          ><v-icon color="#000000" small>mdi-facebook</v-icon> @{{obj.handle}}</a>
                          <a
                            v-else-if="obj.linkedin"
                          ><v-icon color="#0A66C2" small>mdi-linkedin</v-icon> @{{obj.handle}}</a>
                          <a
                            v-else-if="obj.twitter"
                          ><img src="/static/img/x-logo.svg" width="15px" alt="" aria-hidden="true" /> @{{obj.handle}}</a>
                          <a
                            v-else-if="obj.tiktok"
                          ><img src="/static/img/tiktok-32.png" width="20px" /> @{{obj.handle}}</a>
                          <a
                            v-else-if="obj.youtube"
                          ><v-icon>mdi-youtube</v-icon> @{{obj.handle}}</a>
                          <a
                            v-else
                          ><v-icon color="#000000" small>mdi-instagram</v-icon> @{{obj.handle}}</a>
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </td>
                <td>{{ formatDeliverableDetails(item.deliverablesDisplay) }}</td>
                <td>{{ formatDeliverableCounts(item.producedDeliverables) }}</td>
                <td class="text-right">
                  <span v-if="!item.GSTIncluded">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <div v-on="on">
                          {{utilsFunc.currencySym(item.currency)}} {{item.payoutAmount | thousandSeprator}}
                        </div>
                      </template>
                      <span>{{item.currency}} {{item.payoutAmount | thousandSeprator}}</span><br>
                      <span v-if="item.sgdAmt">Estimated SGD: {{item.sgdAmt&&!Number.isNaN(Number(item.sgdAmt))? item.sgdAmt:""}}</span>
                    </v-tooltip>
                  </span>
                  <span data-toggle="tooltip" data-placement="top" :title="displayGSTText(item)" v-if="item.GSTIncluded">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <div v-on="on">
                          {{utilsFunc.currencySym(item.currency)}} {{item.payoutAmount | thousandSeprator}}
                        </div>
                      </template>
                      <span>{{item.currency}} {{item.payoutAmount | thousandSeprator}}</span><br>
                      <span v-if="item.sgdAmt">Estimated SGD: {{item.sgdAmt&&!Number.isNaN(Number(item.sgdAmt))? item.sgdAmt:""}}</span>
                    </v-tooltip>
                  </span>
                  <v-icon
                  small
                  color="secondary"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="GST Included"
                  v-if="item.GSTIncluded">mdi-alert-circle-outline</v-icon>
                </td>
                <td class="text-center">{{ formatSubmissionDate(item.pairing_details.submission_date) }}</td>
                <td style="min-width:12rem;">
                  <!-- <div>
                    <v-chip color="secondary" v-if="item.payout_details && item.payout_details.status !== payoutStatus.CONFIRMED" outlined small>
                      <v-icon v-on="on" small left>new_releases</v-icon>  Pending Payout
                    </v-chip>
                    <v-chip color="green" v-if="item.payout_details && item.payout_details.status === payoutStatus.CONFIRMED" outlined small>
                      <v-icon v-on="on" small left>done</v-icon>  Confirmed
                    </v-chip>
                  </div> -->
                  <div>
                    <v-btn class="mb-1" color="primary" small @click="updateSend(item)" v-if="item.payout_details && item.payout_details.status !== payoutStatus.CONFIRMED && !isAM">
                      <v-icon small left>new_releases</v-icon>&nbsp;Confirm Payout
                    </v-btn>
                    <v-chip color="green" v-if="item.payout_details && item.payout_details.status === payoutStatus.CONFIRMED" outlined small>
                      <v-icon v-on="on" small left>done</v-icon>Confirmed
                    </v-chip>
                    <v-btn text small color="error" @click="cancelPayout(item)" v-if="item.payout_details && item.payout_details.status === payoutStatus.CONFIRMED && !isAM" :disabled="disableLockedCOGS">
                      <v-icon x-small data-toggle="tooltip" data-placement="button" title="Click to cancel Payout">mdi-cancel</v-icon>
                    </v-btn>
                  </div>
                  <!-- {{ pairingSendStatusDisplay[item.sentStatus || 0] }} -->
                </td>
                <td>
                  <div>
                    <v-chip color="error" v-if="!item.inReport" outlined small :to="('/campaign-report-internal?id='+campaignID)" target="_blank" data-toggle="tooltip" data-placement="top" title="Click to add contents to Report">
                      <v-icon v-on="on" small left>warning</v-icon> Pending in Report
                    </v-chip>
                    <v-chip color="green" v-if="item.inReport" outlined small :to="('/campaign-report-internal?id='+campaignID)" target="_blank">
                      <v-icon v-on="on" small left>done</v-icon> Present in Report
                    </v-chip>
                  </div>
                </td>
                <td>
                  <div class="payment-status-list" v-for="(p, index) in item.paymentStatusDisplay" :key="index">
                    <v-chip
                      v-if="(p !== null && p.statusDisplay)"
                      class="payment-status-chip"
                      :class="`payment-status-chip--${p.statusDisplay.value}`"
                      outlined
                      small
                      :style="{ borderColor: p.statusDisplay.color || 'var(--ims-color-secondary)' }"
                      :to="('/finance/payment-consolidation')"
                      target="_blank"
                    >
                      <v-tooltip v-if="p.imported" bottom>
                        <template v-slot:activator="{ on }">
                          <span
                            class="payment-status-imported-badge"
                            aria-label="Imported payment"
                            v-on="on"
                          >
                            <v-icon class="payment-status-icon" small>mdi-newspaper-plus</v-icon>
                          </span>
                        </template>
                        <span>Imported payment</span>
                      </v-tooltip>
                      <span
                        class="payment-status-label"
                        :style="{ color: p.statusDisplay.color || 'var(--ims-color-secondary)' }"
                      >
                        {{p.statusDisplay.text}}
                      </span>
                      <span class="payment-status-divider" aria-hidden="true"></span>
                      <v-tooltip bottom v-if="p.payConsAmt">
                        <template v-slot:activator="{ on }">
                          <span class="payment-status-amount" v-on="on">
                            {{utilsFunc.currencySym(p.currency)}} {{p.payConsAmt | thousandSeprator}}
                          </span>
                        </template>
                        <span>{{p.currency}} {{p.payConsAmt | thousandSeprator}}</span><br>
                        <span v-if="p.sgdAmt">Estimated SGD: {{p.sgdAmt&&!Number.isNaN(Number(p.sgdAmt))? p.sgdAmt:""}}</span>
                      </v-tooltip>
                    </v-chip>
                  </div>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <!-- End of Pairing Data Table -->

    <!-- Influencer Detail Modal -->
    <influencer-detail-modal
      :dialog="dialog"
      :influencer="influencer"
      :influencerProfile="influencerProfile"
      :selectedTab="selectedTab"
      :briefDetailContent="briefDetailsHTML"
      :close="closeModal"
      @loadInfluencer="loadInfluencerData"
      @reRenderDatTable="loadInfluencerData"
      @loadingDialogOpen="loadingDialogOpen"
      @loadingDialogClose="loadingDialogClose"
      :newPairingFlow="true"
      :isDownload="invoiceDownload" />
    <!-- End of Influencer Detail Modal -->

    <v-dialog
      v-model="loadingDialog"
      persistent
      width="300"
    >
      <v-card
        color="primary"
      >
        <v-card-text class="loading-dialog-text">
          Please stand by
          <v-progress-linear
            indeterminate
            color="secondary"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
/* eslint-disable */
import campaignConfig from '../config';
import campaignHelper from '../campaignHelper';
import campaignAPIs from '../campaignAPIs';
import clientAPIs from '../../Client/clientAPIs';
import UserAPIs from '../../User/userAPIs'
import pairingAPIs from '../../Pairing/pairingAPIs';
import config from '@/config';
import utils from '../../../../utils'
import influencerDetailModal from './InfluencerDetailViewModal'
import CampaignListPaymentStatus from './CampaignListPaymentStatus'
import BlocksToHtml from '../../../editor/generator/blocksToHtml'
import SocialHandle from '../../../scoped/custom/SocialHandle'
import reverse from 'lodash/reverse'
import { mapState, mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'payment-consolidation-status',
  components: {
    influencerDetailModal,
    SocialHandle,
    CampaignListPaymentStatus
  },
  data() {
    return {
      loading: false,
      utilsFunc: utils.func,
      influencerList: [],
      totalInfluencer: 0,
      search: '',
      briefConfirmationSearch: '',
      filter: '',
      options: {},
      snack: false,
      snackColor: '',
      snackText: '',
      amount: 0,
      dialog: false, // for Influencer Detail Modal
      influencer: '', // for Influencer Detail Modal
      influencerProfile: '', // for Influencer Detail Modal
      loadAllQuestoins: [],
      selectedTab: '',
      loadingDialog: false,
      briefDetailContent: {
        time: Date.now(),
        blocks: []
      },
      briefDetailsHTML: '',
      campaignList: [],
      sharedDataPromise: null,
      paymentListsPromise: null,
      paymentListsLoaded: false,
      // Current selected campaign
      campaignID: '',
      pairedID: '',
      pairedInfluencers: [],
      preProcessingPayments: [],
      importedPayments: [],
      formattedCompletedPayments: [],
      financePayments: [],
      campaignCOEB: {},
      payoutStatusDisplay: campaignConfig.payoutStatusDisplay,
      payoutStatus: campaignConfig.payoutStatus,
      pairingSendStatusDisplay: campaignConfig.pairingSendStatusDisplay,
      pairingSendStatus: campaignConfig.pairingSendStatus,
      invoiceDownload: false,
      pairedHeaders: [
        {
          text: 'Handle',
          value: 'influencer_details.instagramHandle'
        },
        {
          text: 'Deliverable Details',
          value: 'deliverablesDisplay'
        },
        {
          text: 'Produced Deliverables',
          value: 'producedDeliverables'
        },
        {
          text: 'Payout Amount',
          value: 'payoutAmount'
        },
        {
          text: 'Submission Date',
          value: 'submission_date'
        },
        {
          text: 'Payout Confirmation',
          value: ''
        },
        {
          text: 'Content Status',
          value: ''
        },
        {
          text: 'Payment Status',
          value: 'paymentStatusDisplay'
        }
      ]
    };
  },
  async mounted() {
    // These are only required when a campaign table is opened.  Start them
    // now, but do not make the empty-state campaign picker wait for them.
    this.sharedDataPromise = Promise.all([
      this.getAllUsers(),
      this.$store.dispatch('payment/getCurrencyRates')
    ])
    await this.fetchCampaignList()
    // The picker is usable as soon as campaign names are available.  Its
    // compact payout/content chips are filled in independently below; the
    // four full Payment Collection lists are intentionally deferred until a
    // campaign is selected.
    this.loadCampaignSummary()
  },
  watch: {
    campaignID(value) {
      if (!value) {
        this.clearCampaignSelection()
        return
      }
       this.getPairedInfluencers(value, false);
    }
  },
  computed: {
    ...mapState({
      reports: state => state.campaign.reports,
      completedPayments: state => state.payment.completedPayments,
      currencyRates: state => state.payment.currencyRates,
      infDetail: state => state.influencer.infDetail
    }),
    ...mapGetters('pairing', {
      pairingStatus: 'status'
    }),
    ...mapGetters('payment', [
      'getPaymentStatus',
      'formatPreProcessingPayments',
      'formatImportedPayments',
      'formatCompletedPayments',
      'formatFinancePayments',
      'getPaymentConsolidationStatusDisplay',
      'isPaymentConsolidationRecordMatch'
    ]),
    params(nv) {
      return {
        ...this.options
      };
    },
    currentUser() {
      return this.$store.state.user;
    },
    budget: function() {
      return Math.floor(this.campaignCOEB.budget * 0.3);
    },
    disableLockedCOGS() {
      return this.campaignCOEB.lockedCOGS || false
    },
    isAM() {
      return this.currentUser.role === config.userRoles.ACCOUNT_MANAGER
    }
  },
  methods: {
    formatDeliverableDetails(value) {
      return this.formatDeliverableCounts(value).replace(/X\s*\(Twitter\)\s*Post/g, 'XTP')
    },
    formatDeliverableCounts(value) {
      return String(value || '').replace(/(\d+(?:hrs)?) X /g, '$1 x ')
    },
    async getPairedInfluencers(campaignID, refresh = false) {
      if (!campaignID) {
        this.clearCampaignSelection()
        return
      }

      this.loadingDialog = true
      try {
        return await this.loadPairedInfluencers(campaignID, refresh)
      } catch (error) {
        console.error('Unable to load campaign payment status:', error)
      } finally {
        this.loadingDialog = false
      }
    },
    clearCampaignSelection() {
      this.loadingDialog = false
      this.pairedInfluencers = []
      this.campaignCOEB = {}
    },
    async loadPairedInfluencers(campaignID, refresh = false) {
      // clean the data
      this.pairedInfluencers = Object.assign([], {})
      this.campaignCOEB = Object.assign({}, {})

      // Load the campaign and its pairings before reconciliation.  These are
      // the business inputs: payout confirmation comes from the pairing and
      // content presence comes from matching the pairing to campaign reports.
      const [campaignResp, pairingResp] = await Promise.all([
        campaignAPIs.getCampaign(campaignID),
        pairingAPIs.getPairedInfluencersByCampaign(campaignID)
      ])
      if (campaignResp) {
        if (campaignResp.campaignType === undefined || !campaignHelper.isOtherCampaign(campaignResp.campaignType)) {
          this.$swal({
            title: 'Error',
            text: 'Invalid Campaign Type!',
            type: 'error'
          }).then(() => {
          });
          return false
        }
        // Client details do not depend on report reconciliation, so allow that
        // lookup to run while campaign reports are being loaded/refreshed.
        const clientPromise = clientAPIs.getClient(campaignResp.clientID)
        await this.sharedDataPromise
        await this.$store.dispatch('campaign/getReportsByCampaignIDRefresh', {
          campaignIDs: [campaignID],
          refresh
        })
        // Full Payment Collection records are needed for the selected
        // campaign's row-level Payment Status only.  Do not download every
        // collection while the user is still choosing a campaign.
        await this.ensurePaymentLists(refresh)
        const client = await clientPromise
        const Users = this.Users.filter(c => (campaignResp.assignedTo && campaignResp.assignedTo.includes(c.id)))
        this.campaignCOEB = Object.assign(
          {},
          {
            campaignId: campaignResp.id,
            campaignName: campaignResp.name,
            companyID: campaignResp.companyID,
            clientID: campaignResp.clientID,
            ioNumbers: campaignResp.ioNumbers,
            clientName: client.name,
            Users,
            campaignOutreach: campaignResp.outreach,
            campaignEngagement: campaignResp.engagement,
            campaignBudget: campaignResp.budget,
            max_content: campaignResp.max_content,
            min_content: campaignResp.min_content,
            outreach: campaignResp.outreach,
            engagement: campaignResp.engagement,
            budget: campaignResp.budget,
            campaign_brief_details: campaignResp,
            lockedCOGS: campaignResp.lockedCOGS || false
          }
        )
      }
      if (pairingResp) {
        let items = [];
        for (let data of pairingResp) {
          // getPairedInfluencersByCampaign returns every pairing record for the campaign,
          // including stale/rejected duplicates (e.g. a creator re-paired after an earlier
          // pairing fell through). Reconciliation happens on the server for ACCEPTED
          // pairings only; the table follows the same rule so stale duplicates cannot
          // masquerade as a current payout owner.
          const isAccepted = data.pairing_details && data.pairing_details.status === campaignConfig.pairingStatus.ACCEPTED
          if (isAccepted) {
            let inf = await this.beautifyData(data);
            items.push(inf);
          }
        }
        this.pairedInfluencers = Object.assign([], items)
      }
      await this.setMultipleInfs();
    },
    async setMultipleInfs() {
      const connectedItems = []
      for (let item of this.pairedInfluencers) {
        // Pairings are the authoritative source for the account used in this
        // campaign. Do not fall back to an exact-handle lookup: it is an N+1
        // request, commonly returns no data for legacy/secondary accounts,
        // and cannot safely establish ownership.
        let infID = item.influencer_details && item.influencer_details.influencerID
        // Pairings also contain valid secondary/legacy accounts. Merge them
        // by stable influencerID; never infer ownership from handle alone.
        let infs = this.getPairedAccountOptions(infID)
        if (infID) {
          await this.$store.dispatch('influencer/getInfluencerDetail', {
            id: infID
          })
          if (!this.isCurrentPlatformConnected(item, this.infDetail)) {
            continue
          }
          infs.push(...this.getProfileAccountOptions(item.id))
        }
        item.multipleInfs = this.uniqueAccountOptions(infs)
        connectedItems.push(item)
      }
      this.pairedInfluencers = connectedItems
    },
    isCurrentPlatformConnected(item, influencer) {
      const details = item.influencer_details || {}
      const platform = String(details.platform || item.platform || 'instagram').toLowerCase()
      const platformKey = platform === 'x' ? 'twitter' : platform
      const connectedPlatformKeys = ['instagram', 'tiktok', 'youtube', 'xiaohongshu', 'facebook', 'linkedin', 'twitter']
      return !connectedPlatformKeys.includes(platformKey) || Boolean(influencer && influencer[platformKey])
    },
    getPairedAccountOptions(influencerID) {
      if (!influencerID) return []
      return this.pairedInfluencers
        .filter(item => item.influencer_details && item.influencer_details.influencerID === influencerID)
        .map(item => this.createPairingAccountOption(item))
        .filter(Boolean)
    },
    getPlatformHandle(details, platform) {
      const account = details || {}
      switch (String(platform || account.platform || 'instagram').toLowerCase()) {
        case 'facebook':
          return account.facebookHandle || account.fbHandle || (account.facebook && account.facebook.handle) || account.userHandle || account.instagramHandle || ''
        case 'twitter':
        case 'x':
          return account.twitterHandle || account.xHandle || (account.twitter && account.twitter.twitterHandle) || account.userHandle || account.instagramHandle || ''
        case 'linkedin':
          return account.linkedinHandle || (account.linkedin && account.linkedin.linkedinHandle) || account.userHandle || account.instagramHandle || ''
        case 'tiktok':
          return account.tiktokHandle || account.userHandle || account.instagramHandle || ''
        case 'youtube':
          return account.youtubeHandle || account.userHandle || account.instagramHandle || ''
        default:
          return account.userHandle || account.instagramHandle || ''
      }
    },
    createPairingAccountOption(item) {
      const details = item.influencer_details || {}
      const platform = String(details.platform || 'instagram').toLowerCase()
      const normalizedPlatform = platform === 'x' ? 'twitter' : platform
      const handle = this.getPlatformHandle(details, normalizedPlatform)
      if (!handle) return null
      const option = {
        reportID: item.id,
        platform: normalizedPlatform === 'tiktok' ? 'TikTok' : normalizedPlatform === 'youtube' ? 'Youtube' : normalizedPlatform === 'xiaohongshu' ? 'Xiaohongshu' : normalizedPlatform === 'facebook' ? 'Facebook' : normalizedPlatform === 'linkedin' ? 'LinkedIn' : normalizedPlatform === 'twitter' ? 'X (Twitter)' : 'Instagram',
        handle,
        picture: details.picture || ''
      }
      const platformFlag = normalizedPlatform === 'xiaohongshu' ? 'xhs' : (normalizedPlatform === 'others' ? 'instagram' : normalizedPlatform)
      option[platformFlag] = true
      return option
    },
    getProfileAccountOptions(reportID) {
      const infs = []
      if (this.infDetail.instagram) infs.push({ reportID, platform: 'Instagram', handle: this.infDetail.instagram.instagramHandle, instagram: true })
      if (this.infDetail.tiktok) infs.push({ reportID, platform: 'TikTok', handle: this.infDetail.tiktok.tiktokHandle, tiktok: true })
      if (this.infDetail.youtube) infs.push({ reportID, platform: 'Youtube', handle: this.infDetail.youtube.youtubeHandle, youtube: true })
      if (this.infDetail.xiaohongshu) infs.push({ reportID, platform: 'Xiaohongshu', handle: this.infDetail.xiaohongshu.xhsHandle, xhs: true })
      if (this.infDetail.facebook) infs.push({ reportID, platform: 'Facebook', handle: this.infDetail.facebook.handle, facebook: true })
      if (this.infDetail.linkedin) infs.push({ reportID, platform: 'LinkedIn', handle: this.infDetail.linkedin.linkedinHandle, linkedin: true })
      if (this.infDetail.twitter) infs.push({ reportID, platform: 'X (Twitter)', handle: this.infDetail.twitter.twitterHandle, twitter: true })
      return infs.filter(inf => inf.handle)
    },
    uniqueAccountOptions(accounts) {
      const seen = new Set()
      return accounts.filter(account => {
        const key = `${account.platform}:${String(account.handle).trim().toLowerCase()}`
        if (seen.has(key)) return false
        seen.add(key)
        return true
      })
    },
    async fetchPairedInfluencerFromAPI(page, limit) {
      let userID;
      if (this.currentUser.role === config.userRoles.AD_STRATEGIST || this.currentUser.role === config.userRoles.ACCOUNT_MANAGER) {
        userID = this.currentUser.id;
      }
      const influencer = await pairingAPIs.getAllPairedInfluencer(userID, page, limit);
      // this.influencerList = influencer;
      return influencer;
    },
    searchClick() {
      if (this.search) {
        this.loading = true;
        let userID;
        let search = this.search.trim().toLowerCase();
        if (this.currentUser.role === config.userRoles.AD_STRATEGIST || this.currentUser.role === config.userRoles.ACCOUNT_MANAGER) {
          userID = this.currentUser.id;
        }
        pairingAPIs.getAllPairedInfluencer(userID).then(data => {
          if (search) {
            data.items = data.items.filter(item => {
              return Object.values(item).join(',').toLowerCase().includes(search);
            });
          }
          this.influencerList = data.items;
          this.totalInfluencer = data.items.length
          this.loading = false;
        });
      } else this.loadInfluencerData(); // default data
    },
    loadInfluencerData() {
      this.getPairedInfluencers(this.campaignID)
      this.campaignList = []
      setTimeout(async () => {
        // fetchCampaignList resets every option to statusLoading: true, so
        // the summary chips must be reloaded on every reload path, not just
        // the initial mount.
        await this.fetchCampaignList()
        this.loadCampaignSummary()
      }, 1000)
    },
    prepareDataTable() {
      return new Promise((resolve, reject) => {
        const { sortBy, sortDesc, page, itemsPerPage } = this.options;
        this.fetchPairedInfluencerFromAPI(page, itemsPerPage).then(data => {
          if (this.options.sortBy) {
            data.items = data.items.sort((a, b) => {
              const sortA = a[sortBy[0]];
              const sortB = b[sortBy[0]];

              if (sortDesc[0]) {
                if (sortA < sortB) return 1;
                if (sortA > sortB) return -1;
                return 0;
              } else {
                if (sortA < sortB) return -1;
                if (sortA > sortB) return 1;
                return 0;
              }
            });
          }
          const total = data.totalRows;
          setTimeout(() => {
            resolve({ items: data.items, total });
          }, 300);
        });
      });
    },
    getStatusColor(status) {
      if (status) {
        if (status === this.pairingStatus.INVITED.value) {
          return 'orange';
        } else if (status === this.pairingStatus.INTERESTED.value) {
          return '#81C784';
        } else if (status === this.pairingStatus.NOT_INTERESTED.value) {
          return 'red';
        } else if (status === this.pairingStatus.ACCEPTED.value) {
          return '#66BB6A';
        } else if (status === this.pairingStatus.NOT_ACCEPTED.value) {
          return 'red';
        } else if (status === this.pairingStatus.INQUIRY.value) {
          return '#1E88E5';
        } else return 'white';
      }
    },
    payoutStatusColor(status) {
      if (status === this.payoutStatus.PENDING) {
        return ''
      } else if (status === this.payoutStatus.INCOMPLETE) {
        return 'warning'
      } else {
        return 'green'
      }
    },
    getUserByInfluencer(id) {
      // console.log('influencerID', id)
      let param = {
        'influencerID': id
      }
      UserAPIs.getUserByInfluencer(param)
      .then(res => {
        // console.log('Response user by influencerID', res)
        this.influencerProfile = res
      })
    },
    preSelectTabs (status) {
      if (status === this.pairingStatus.INQUIRY.value) {
        this.selectedTab = 1
      } else {
        this.selectedTab = 0
      }
    },
    async preparedViewItem(item, type) {
      // Get Influencer user profile only if have InfluencerID
      if (item.influencerID) {
        this.getUserByInfluencer(item.influencerID)
      }
      this.influencer = Object.assign({}, item)
      // ---------- if HTML data, get content HTML ----------
      if (item.brief_details && item.brief_details.contentHTML !== undefined && item.brief_details.contentHTML !== null) {
        this.briefDetailsHTML = item.brief_details.contentHTML
        this.selectedTab = type
        return;
      }
      let oldData = false
      if (item.brief_details && item.brief_details.content !== undefined && item.brief_details.content !== '' && item.brief_details.content.length > 0) {
        this.briefDetailContent.blocks = item.brief_details.content
        oldData = true
      } else {
        this.briefDetailContent.blocks = await campaignHelper.generateBlocks(item)
      }
      let blocksTohtml = new BlocksToHtml(this.briefDetailContent.blocks)
      this.briefDetailsHTML = blocksTohtml.generate(oldData)
      this.selectedTab = type
    },
    async updateSend(item) {
      const payload = this.getRptOwnerCheckPayload(item)
      await campaignHelper.invokeReportOwnerCheck(this, payload)
      let confirmPayoutBlock = campaignConfig.campaignConfirmation.confirmPayout
      let message = confirmPayoutBlock.html
      this.$swal({
        title: confirmPayoutBlock.title,
        html: message,
        confirmButtonText: confirmPayoutBlock.confirmButtonText,
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          this.invoiceDownload = true
          await this.preparedViewItem(item, -1)
          this.selectedTab = -1
          this.dialog = true
        }
      });
    },
    async cancelPayout(item) {
      // const payload = this.getRptOwnerCheckPayload(item)
      // await campaignHelper.invokeReportOwnerCheck(this, payload)
      let cancelPayoutBlock = campaignConfig.campaignConfirmation.cancelPayout
      let message = cancelPayoutBlock.html
      this.$swal({
        title: cancelPayoutBlock.title,
        html: message,
        confirmButtonText: cancelPayoutBlock.confirmButtonText,
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          this.loadingDialog = true
          await pairingAPIs.cancelAdminPayout(item.id)
          this.loadingDialog = false
          this.loadInfluencerData();
        }
      });
    },
    closeModal() {
      this.selectedTab = '';
      this.dialog = false;
    },
    loadingDialogOpen() {
      this.loadingDialog = true
    },
    loadingDialogClose() {
      this.loadingDialog = false
    },
    async beautifyData(data) {
      let inf = {};
      const influencerDetails = data.influencer_details;
      const deliverablesDetails = data.deliverables_details || {};
      const hasProducedDeliverables = value => value !== undefined && value !== null && value !== ''
      // inf = data.influencer_details;
      inf.influencer_details = influencerDetails;
      inf.pairing_details = data.pairing_details
      inf.elimination_details = data.elimination_details
      inf.pairingStatus = data.pairing_details.status;
      inf.status = data.pairing_details.status;
      inf.eliminationStatus = data.elimination_details.status;
      inf.remarks = data.additional_details ? data.additional_details.remarks : '';
      inf.CampaignID = this.campaignCOEB ? this.campaignCOEB.campaignId : '';
      inf.CampaignName = this.campaignCOEB ? this.campaignCOEB.campaignName : '';
      inf.Users = this.campaignCOEB ? this.campaignCOEB.Users : [];
      inf.campaign_brief_details = this.campaignCOEB.campaign_brief_details;
      inf.id = data.id;
      inf.no_of_posts = deliverablesDetails.no_of_posts || 0;
      inf.no_of_video = deliverablesDetails.no_of_video || 0;
      inf.no_of_carousels = deliverablesDetails.no_of_carousels || 0;
      inf.no_of_igTv = deliverablesDetails.no_of_igTv || 0;
      inf.instagramFullname = influencerDetails.fullname;
      inf.no_of_stories = deliverablesDetails.no_of_stories || 0;
      inf.no_of_tiktok_posts = deliverablesDetails.no_of_tiktok_posts || 0;
      inf.no_of_li_posts = deliverablesDetails.no_of_li_posts || 0;
      inf.no_of_x_posts = deliverablesDetails.no_of_x_posts || 0;
      inf.no_of_reels = deliverablesDetails.no_of_reels || 0;
      inf.followers = influencerDetails.followers || 0;
      inf.engagement = influencerDetails.engagements || 0;
      inf.engagement_rate = influencerDetails.engagement_rate || 0;
      inf.deliverables = deliverablesDetails
      inf.deliverablesDisplay = campaignHelper.getDeliverableDetails(deliverablesDetails)
      inf.sentStatus = data.sentStatus || 0
      inf.platform = String(influencerDetails.platform || 'instagram').toLowerCase()
      if (inf.platform === 'x') inf.platform = 'twitter'
      inf.influencer_details.platform = inf.platform
      const platformHandle = this.getPlatformHandle(inf.influencer_details, inf.platform)
      if (!inf.userHandle) inf.userHandle = platformHandle
      if (!inf.influencer_details.userHandle) inf.influencer_details.userHandle = platformHandle
      if (data.payout_details) {
        inf.payout_details = data.payout_details
        inf.payoutAmount = data.payout_details ? data.payout_details.amount : '';
        inf.GSTIncluded = data.payout_details.GSTpercent || false;
        inf.GSTpercent = data.payout_details.GSTpercent
        inf.payout = data.payout_details.amount ? Number(data.payout_details.amount) : 0;
        inf.history = data.payout_details.history ? reverse(data.payout_details.history) : [];
        inf.payoutStatus = data.payout_details.status || 0;
        inf.currency = data.payout_details.currency || 'SGD'
        if (inf.currency !== 'SGD') {
          inf.sgdAmt = utils.func.convertCurrency(inf.currency, inf.payoutAmount, this.currencyRates)
        }
      }
      if (data.brief_details) {
        inf.brief_details = data.brief_details
      }
      inf.paymentStatuses = []
      const infInfluencerID = inf.influencer_details ? inf.influencer_details.influencerID : null
      for (let rpt of this.reports) {
        // Imported payout lines are financial adjustments, not campaign
        // content, so they cannot satisfy the Content Status gate.
        if (rpt.imported) continue
        const rptOwner = this.getReportOwnerIdentity(rpt)
        const isOwnerMatch = (rptOwner.pairingID && rptOwner.pairingID === inf.id) ||
          (infInfluencerID && rptOwner.influencerID && rptOwner.influencerID === infInfluencerID) ||
          (rptOwner.handle && inf.userHandle && rptOwner.handle === String(inf.userHandle).trim().toLowerCase())
        if (isOwnerMatch) {
          inf.inReport = true
          if (hasProducedDeliverables(rpt.producedDeliverables)) {
            inf.producedDeliverables = rpt.producedDeliverables
          } else if (!hasProducedDeliverables(inf.producedDeliverables) && hasProducedDeliverables(rpt.deliverables)) {
            inf.producedDeliverables = rpt.deliverables
          }
        }
      }
      const paymentConsolidationRecords = this.getPaymentConsolidationRecords()
      // set paid status from pre processing payments
      for (let rpt of this.preProcessingPayments) {
        if (rpt.campaign.id === inf.CampaignID) {
          if (rpt.influencer_details) {
            if (this.isPaymentConsolidationRecordMatch(rpt, inf.CampaignID, inf.userHandle, infInfluencerID)) {
              // confirm for payout status
              inf.inReport = true
              if (!inf.producedDeliverables) {
                inf.producedDeliverables = rpt.deliverables
              }
              // let arrPaymentStatuses = [...inf.paymentStatuses]
              // let matchStatus = arrPaymentStatuses.find(p => p.payment_status === campaignConfig.paymentStatus.PAID && !p.imported)
              // if (!matchStatus) {
              //   rpt.payment_status = campaignConfig.paymentStatus.PAID
              //   inf.paymentStatuses.add(rpt)
              // }
              rpt.payment_status = campaignConfig.paymentStatus.PROCESSING
              inf.paymentStatuses.push(rpt)
            }
          }
        }
      }
      
      // set paid status from pre processing payments
      for (let rpt of this.importedPayments) {
        if (rpt.campaign.id === inf.CampaignID) {
          if (rpt.influencer_details) {
            if (this.isPaymentConsolidationRecordMatch(rpt, inf.CampaignID, inf.userHandle, infInfluencerID)) {
              // confirm for payout status
              inf.inReport = true
              if (!inf.producedDeliverables) {
                inf.producedDeliverables = rpt.deliverables
              }
              // let arrPaymentStatuses = [...inf.paymentStatuses]
              // let matchStatus = arrPaymentStatuses.find(p => p.payment_status === campaignConfig.paymentStatus.PAID && !p.imported)
              // if (!matchStatus) {
              //   rpt.payment_status = campaignConfig.paymentStatus.PAID
              //   inf.paymentStatuses.add(rpt)
              // }
              rpt.payment_status = campaignConfig.paymentStatus.PROCESSING
              inf.paymentStatuses.push(rpt)
            }
          }
        }
      }
      // set paid status from completed payments
      for (let rpt of this.formattedCompletedPayments) {
        if (rpt.campaign.id === inf.CampaignID) {
          if (rpt.influencer_details) {
            if (this.isPaymentConsolidationRecordMatch(rpt, inf.CampaignID, inf.userHandle, infInfluencerID)) {
              // confirm for payout status
              inf.inReport = true
              if (!inf.producedDeliverables) {
                inf.producedDeliverables = rpt.deliverables
              }
              // let arrPaymentStatuses = [...inf.paymentStatuses]
              // let matchStatus = arrPaymentStatuses.find(p => p.payment_status === campaignConfig.paymentStatus.PAID && !p.imported)
              // if (!matchStatus) {
              //   rpt.payment_status = campaignConfig.paymentStatus.PAID
              //   inf.paymentStatuses.add(rpt)
              // }
              rpt.payment_status = campaignConfig.paymentStatus.PAID
              inf.paymentStatuses.push(rpt)
            }
          }
        }
      }
       // set wip finance, approval finance status from finance payments
      for (let rpt of this.financePayments) {
        if (rpt.campaign.id === inf.CampaignID) {
          if (rpt.influencer_details) {
            if (this.isPaymentConsolidationRecordMatch(rpt, inf.CampaignID, inf.userHandle, infInfluencerID)) {
              // confirm for payout status
              inf.inReport = true
              if (!inf.producedDeliverables) {
                inf.producedDeliverables = rpt.deliverables
              }
              // let arrPaymentStatuses = [...inf.paymentStatuses]
              // let matchStatus = arrPaymentStatuses.find(p => (p.payment_status === campaignConfig.paymentStatus.PARTIAL
              // || p.payment_status === campaignConfig.paymentStatus.APPROVAL_FINANCE))
              // console.log(rpt, matchStatus)
              // if (!matchStatus) {
              //   rpt.payment_status = rpt.status
              //   inf.paymentStatuses.add(rpt)
              // }
              rpt.payment_status = rpt.status
              inf.paymentStatuses.push(rpt)
            }
          }
        }
      }
      inf.paymentStatuses = [...inf.paymentStatuses]
      inf.paymentStatusDisplay = this.getPaymentConsolidationStatusDisplay(
        paymentConsolidationRecords,
        inf.CampaignID,
        inf.userHandle,
        infInfluencerID,
        inf.id
      )
      return inf;
    },
    // A report's owner handle/influencerID can live in different places depending on how the
    // content was added (post_details.owner for regular IG posts, owner for stories/other
    // platforms/imported content). influencerID is checked in priority order - top-level
    // rpt.influencerID first (how CC-imported/secondary-handle reports commonly carry it),
    // then the owner object - since it's stable across all of an influencer's connected
    // handles, unlike the handle string.
    getReportOwnerIdentity(rpt) {
      if (!rpt) return { pairingID: null, handle: null, influencerID: null }
      const ownerObj = (rpt.success && rpt.post_details && rpt.post_details.owner)
        ? rpt.post_details.owner
        : (rpt.owner && typeof rpt.owner === 'object' ? rpt.owner : null)
      const rawHandle = ownerObj && ownerObj.username
        ? ownerObj.username
        : (typeof rpt.owner === 'string' ? rpt.owner : rpt.instagram)
      const handle = rawHandle ? String(rawHandle).trim().toLowerCase() : null
      const influencerID = rpt.influencerID || (ownerObj ? ownerObj.influencerID : null) || null
      const pairingID = rpt.pairingID || (ownerObj ? ownerObj.pairingID : null) || null
      return { pairingID, handle, influencerID }
    },
    getPaymentConsolidationRecords() {
      return [
        ...this.preProcessingPayments,
        ...this.importedPayments,
        ...this.financePayments,
        ...this.formattedCompletedPayments
      ]
    },
    async refreshPaymentLists() {
      // These actions write to separate Vuex keys and the page needs all four
      // stages, so they can be fetched concurrently without changing results.
      await Promise.all([
        this.getPreProcessingPayments(),
        this.getImportedPayments(),
        this.getCompletedPayment(),
        this.fetchFinancePayments()
      ])
    },
    async ensurePaymentLists(refresh = false) {
      if (!refresh && this.paymentListsLoaded) return
      if (!refresh && this.paymentListsPromise) return this.paymentListsPromise

      this.paymentListsPromise = this.refreshPaymentLists()
        .then(() => {
          this.paymentListsLoaded = true
        })
        .finally(() => {
          this.paymentListsPromise = null
        })
      return this.paymentListsPromise
    },
    async getAllUsers() {
      // Both roles are used for campaign assignment labels. Wait for both so
      // payment/campaign formatting cannot race the Account Manager request.
      const [coResponse, amResponse] = await Promise.all([
        UserAPIs.getAllUsersByRole(config.userRoles.AD_STRATEGIST),
        // Preserve the previous non-blocking AM failure behavior: CC data is
        // sufficient for the page to load if the secondary lookup fails.
        UserAPIs.getAllUsersByRole(config.userRoles.ACCOUNT_MANAGER).catch(error => {
          console.log('error', error)
          return { users: [] }
        })
      ])
      this.Users = [...coResponse.users, ...amResponse.users].map(user => {
        user.name = `${user.firstName} ${user.lastName}`
        return user
      })
    },
    async fetchCampaignList() {
      this.loadingDialog = true
      try {
        // Direct links already identify the campaign. Avoid downloading the
        // entire campaign catalogue when only that campaign can be selected.
        const response = this.$route.query.id
          ? [await campaignAPIs.getCampaign(this.$route.query.id)]
          : await campaignAPIs.getAllCampaignsNoStatus() // In future, Campaign status could be change
        let campaigns = response.filter(Boolean)
        campaigns = campaigns.filter(c => (c.status === config.campaignStatus.PAIRING_INFLUENCER || c.status === config.campaignStatus.ONGOING || c.status === config.campaignStatus.REVIEW || c.status === config.campaignStatus.COMPLETE))
        // filter Others campaign
        // campaigns = campaigns.filter(campaign => {
        //   if (campaign.campaignType !== undefined) {
        //     if (campaignHelper.isOtherCampaign(campaign.campaignType)) {
        //       return true
        //     }
        //   }
        //   return false
        // })
        this.campaignList = campaigns.map(element => {
          return {
            name: element.name,
            ioNumber: element.ioNumbers || '',
            // Vuetify filters autocomplete items through item-text. Keep the
            // visual fields separate while making both IO and name searchable.
            searchText: element.ioNumbers ? `${element.ioNumbers} - ${element.name}` : element.name,
            id: element.id,
            lockedCOGS: element.lockedCOGS || false,
            statusLoading: true,
            statusUnavailable: false
            // payoutStatus: element.payoutStatus || false
          };
        })
        if (this.$route.query.id) {
          this.campaignID = this.$route.query.id
          this.campaignList = this.campaignList.filter(c => c.id === this.campaignID)
        }
        this.loadingDialog = false
      } catch (err) {
        this.loadingDialog = false
        console.log('Error:' + err);
      }
    },
    async loadCampaignSummary() {
      const campaignIDs = this.campaignList.map(element => element.id)
      if (!campaignIDs.length) return

      try {
        // This preserves the campaign issue chips without coupling them to
        // either the selected campaign or the much larger payment lists.
        const summaries = await pairingAPIs.getCampaignPaymentStatusSummary(campaignIDs)
        this.setCampaignRptPaymentStatus(summaries)
      } catch (error) {
        console.error('Unable to load campaign payment summaries:', error)
        this.campaignList.forEach(campaign => {
          campaign.statusUnavailable = true
        })
      } finally {
        this.campaignList.forEach(campaign => {
          campaign.statusLoading = false
        })
      }
    },
    setCampaignRptPaymentStatus(summaries = []) {
      const summariesByCampaign = summaries.reduce((result, summary) => {
        result[summary.campaignID] = summary
        return result
      }, {})
      this.campaignList.forEach(campaign => {
        const summary = summariesByCampaign[campaign.id]
        campaign.payoutStatus = summary && summary.allPayoutsConfirmed
          ? this.payoutStatus.CONFIRMED
          : null
        campaign.inReport = Boolean(summary && summary.allAcceptedPairingsInReport)
      })
    },
    getRptOwnerCheckPayload(item) {
      return Object.assign({}, {
        campaignID: item.CampaignID,
        handle: item.influencer_details ? item.influencer_details.instagramHandle : null,
        platform: item.influencer_details ? item.influencer_details.platform : null
      })
    },
    formatSubmissionDate(date) {
      return date ? moment(date).format('DD/MM/yyyy') : 'Empty!'
    },
    displayGSTText(item) {
      return `$${item.payoutAmount - item.GSTpercent} + $${item.GSTpercent} (GST)`
    },
    async getPreProcessingPayments() {
      // get completed reports
      await this.$store.dispatch('payment/getPreProcessingPayments', {})
      this.preProcessingPayments = this.formatPreProcessingPayments(this.Users)
    },
    async getImportedPayments() {
      // get completed reports
      await this.$store.dispatch('payment/getImportedPayments', {})
      this.importedPayments = this.formatImportedPayments(this.Users)
    },
    async getCompletedPayment() {
      // get completed reports
      await this.$store.dispatch('payment/getCompletedPayments', {})
      this.formattedCompletedPayments = this.formatCompletedPayments(this.Users)
    },
    async fetchFinancePayments() {
      // get completed reports
      await this.$store.dispatch('payment/getFinancePayments', {})
      this.financePayments = this.formatFinancePayments(this.Users)
    }
  }
};
</script>

<style scoped>
.payment-status-handle {
  align-items: center;
  display: inline-flex;
  flex-wrap: nowrap;
  max-width: 100%;
  white-space: nowrap;
}
.campaign-payment-selection {
  display: flex;
  align-items: baseline;
  gap: 8px;
  min-width: 0;
  max-width: 100%;
}
.campaign-payment-selection__name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.campaign-payment-selection__io {
  flex: 0 0 auto;
  color: var(--ims-color-muted, #6b7280);
  font-size: 12px;
}
.payment-status-list {
  padding: 3px 0;
}
.payment-status-chip {
  display: inline-flex;
  width: 100%;
  max-width: 250px;
  min-width: 190px;
  justify-content: flex-start;
  border-width: 1px !important;
  background: #fff !important;
  color: var(--ims-color-ink) !important;
  transition: background-color 120ms ease, border-color 120ms ease;
}
.payment-status-chip:hover,
.payment-status-chip:focus {
  background: #f4f4f4 !important;
  color: var(--ims-color-ink) !important;
}
.payment-status-chip::before{
  background-color:#FFF !important;
}
.payment-status-chip--1,
.payment-status-chip--1:hover,
.payment-status-chip--1:focus {
  background: #edf7ef !important;
}
.payment-status-chip--3,
.payment-status-chip--3:hover,
.payment-status-chip--3:focus {
  background: #fff7dc !important;
}
.payment-status-chip--5,
.payment-status-chip--5:hover,
.payment-status-chip--5:focus,
.payment-status-chip--6,
.payment-status-chip--6:hover,
.payment-status-chip--6:focus {
  background: #eeeeff !important;
}
.payment-status-chip .v-chip__content {
  display: flex;
  width: 100%;
  min-width: 0;
  gap: 6px;
}
.payment-status-icon {
  flex: 0 0 auto;
}
.payment-status-imported-badge {
  display: inline-flex;
  flex: 0 0 20px;
  width: 20px;
  height: 20px;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(106, 13, 173, 0.28);
  border-radius: 4px;
  background: var(--ims-color-third-soft) !important;
  color: var(--ims-color-third) !important;
}
.payment-status-imported-badge .v-icon {
  color: var(--ims-color-third) !important;
  font-size: 14px !important;
}
.payment-status-label {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 600;
}
.payment-status-divider {
  flex: 0 0 1px;
  align-self: stretch;
  background: #d6d6d6;
}
.payment-status-amount {
  margin-left: auto;
  color: var(--ims-color-ink) !important;
  font-weight: 700;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  min-width: 76px;
  max-width: 76px;
}
.v-card .loading-dialog-text,
.theme--light.v-card .loading-dialog-text,
.theme--dark.v-card .loading-dialog-text {
  color: var(--ims-color-secondary) !important;
  font-weight: 700;
}
</style>

<style>
.payment-status-chip .v-chip__content {
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
  gap: 6px;
}
</style>



// WEBPACK FOOTER //
// PaymentConsolidationStatus.vue?79b507c7